export function generateTagColors(name) {
  let h = 0
  for (let i = 0; i < name.length; i++) {
    h = h * 31 + name.charCodeAt(i)
  }
  // Convert to unsigned 32-bit then mod 360
  const hue = ((h >>> 0) % 360)
  return {
    color_background: `hsl(${hue}, 30%, 85%)`,
    color_font: `hsl(${hue}, 40%, 20%)`,
  }
}

/**
 * Returns the localized name for a tag object or string based on current locale.
 * Supports: 'pt-BR', 'en', 'es', 'fr' (with normalization).
 */
export function getLocalizedTagName(tag, currentLocale = 'pt-BR') {
  if (!tag) return ''
  if (typeof tag === 'string') return tag

  const canonicalName = tag.name || ''
  const translations = tag.translations

  if (!translations || typeof translations !== 'object' || Object.keys(translations).length === 0) {
    return canonicalName
  }

  // Normalize locale
  let lang = currentLocale || 'pt-BR'
  if (translations[lang]) return translations[lang]

  // Map variations (e.g. 'pt' -> 'pt-BR', 'en-US' -> 'en', 'es-ES' -> 'es', 'fr-FR' -> 'fr')
  const shortLang = lang.split('-')[0].toLowerCase()
  if (shortLang === 'pt' && translations['pt-BR']) return translations['pt-BR']
  if (translations[shortLang]) return translations[shortLang]

  // Direct short lookup
  for (const key of Object.keys(translations)) {
    if (key.toLowerCase().startsWith(shortLang)) {
      return translations[key]
    }
  }

  return canonicalName
}

